import { render, staticRenderFns } from "./IconMoreHorizontal.vue?vue&type=template&id=a950fc86"
import script from "./IconMoreHorizontal.vue?vue&type=script&lang=js"
export * from "./IconMoreHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports